import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-automation',
  templateUrl: './automation.component.html',
  imports: [
    RouterOutlet
  ],
  styleUrls: ['./automation.component.scss']
})
export class AutomationComponent implements OnInit {
  constructor() {
  }

  ngOnInit(): void {

  }
}
